import React, {Component} from 'react';
import Grid from "@material-ui/core/Grid";
import {Link} from "react-router-dom";

// images
import bgShape1 from '../../images/bg-shape1.png';
import Shape1 from '../../images/WebsiteBanner.png';

import './style.scss';
import { Hidden } from '@material-ui/core';

class HeroArea extends Component {


    render(){
        return(
            <Grid className="heroAreaWapper">
                <Grid
                    container
                    alignItems="flex-start"
                    className="container">
                    <Grid item xs={12} sm={6}>
                        <Grid className="heroContent">
                            <strong>Tax, CPP and EI Deductions Calculated For You</strong>
                            <h2>Instantly Generate Professional Pay Stubs</h2>
                            <p>OneTwoPay is your simple solution for Canadian pay stubs in just a few quick steps. We make generating professional pay stubs for your employees quick, simple, and stress-free.  </p>
                            <Link to="/about-us" className="cBtn">Sign Up</Link>
                        </Grid>
                    </Grid>
                    <Hidden xsDown>
                        <Grid item xs={12} sm={6}>
                            <Grid className="hrRighThumb">
                                <img src={Shape1} alt=""/>
                            </Grid>
                        </Grid>
                    </Hidden>    
                </Grid>
                <img className="bgShape1" src={bgShape1} alt="shape"/>
            </Grid>
        )
    }
}

export default HeroArea;